import React from 'react';
import IconBase, { TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const MessageIcon = React.memo(function MessageIcon(props: TMessageIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Message" {...props}>
            <path
                clipRule="evenodd"
                fillRule="evenodd"
                d="m4.523 12.894-.446 3.516 3.036-.389.42.224a6.5 6.5 0 1 0-3.12-3.676l.11.325ZM18.578 10.5A8 8 0 0 1 6.83 17.57l-3.206.41a1 1 0 0 1-1.116-1.121l.483-3.813A8 8 0 1 1 18.577 10.5Z"
            />
        </IconBase>
    );
});

export default MessageIcon;

// #region Types

export type TMessageIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <MessageIcon /> : { ...IconBaseExample, render: MessageIcon };

// #endregion
